import script from "./PCInformationBarBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PCInformationBarBlock.vue?vue&type=script&setup=true&lang=js"

import "./PCInformationBarBlock.vue?vue&type=style&index=0&id=2e38fe44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e38fe44"]])

export default __exports__